import { createApi } from '@reduxjs/toolkit/query/react';

import { settings } from '@/_config';

import baseQueryWithReAuth from '../helper/base-query-with-auth';

// Define a service using a base URL and expected endpoints
const customerApis = createApi({
  reducerPath: 'customerApis',
  baseQuery: baseQueryWithReAuth({ baseUrl: settings.baseURL[0], appName: 'ATP', authRequired: true }),
  tagTypes: [
    'AVAILABLE_COURSES',
    'AVAILABLE_AOD_COURSES',
    'COURSE_SURVEYS',
    'COURSE_AOD_BOOKING',
    'REGISTERED_COURSES',
    'EXAMS',
    'CHARGENT_BILLING',
    'CC_PAYMENT_METHODS',
    'STRIPE_CUSTOMERS',
    'STRIPE_BILLING',
    'BILLING',
    'PROFILE',
    'NON_BLOCKING_ACCOUNT_DEPENDENCY',
    'DELINQUENCY_STATE',
  ],
  endpoints: () => ({}),
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export default customerApis;
